import React from 'react';
import Select from 'react-select';
import { FormGroup } from 'reactstrap';
import { observer, inject } from 'mobx-react';
import Logger from 'utils/logger';

@inject('searchFilter')
@observer
class UserTypeFilter extends React.Component {
  handleSelectChange = async e => {
    const { searchFilter, refreshData } = this.props;
    searchFilter.set('selectUserType', {
      label: e.label,
      value: e.value
    });
    await searchFilter.set('page', 1);
    refreshData && (await refreshData());
  };

  render() {
    const { searchFilter } = this.props;
    return (
      <FormGroup>
        <Select
          className="react-select text-left"
          classNamePrefix="react-select"
          name="selectCompany"
          value={searchFilter.selectUserType}
          onChange={this.handleSelectChange}
          options={searchFilter.userTypeList}
          placeholder="권한을 선택하세요."
        />
      </FormGroup>
    );
  }
}

UserTypeFilter.defaultProps = {
  refreshData: async () => {
    Logger.log('[UserTypeFilter] - refresh function is undefined');
  }
};

export default UserTypeFilter;
